import { render } from "./OffDaysManagement.vue?vue&type=template&id=32b76742"
import script from "./OffDaysManagement.vue?vue&type=script&lang=js"
export * from "./OffDaysManagement.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__